export var ANIMATION_KEYS = {
  NAVIGATION_BAR_SHINE: 'navigation-bar-shine',
  NAVIGATION_BUY_BUTTON_SHINE: 'navigation-buy-button-shine',
  MISSIONS_PROGRESS_SHINE: 'missions-progress-shine',
  REWARD_CENTER_ICON_GLOW: 'reward-center-icon-glow',
  EVENTS_ICON: 'events-icon',
  PINNED_PANEL: 'pinned-panel',
  DAILY_SPIN_REWARD: 'daily-spin-reward',
  COLLECT_BONUS: 'collect-bonus',
  PIGGY_BANK_COINS: 'piggy-bank-coins'
};